export default `
  .animFade-enter {
  opacity: 0;
}

.animFade-enter-active {
  opacity: 1;
  transition: opacity 1.5s;
}

.animFade-exit {
  opacity: 0;
}

.animFade-exit-active {
  opacity: 1;
  transition: opacity 1.5s;
}

.animFade-appear {
  opacity: 0;
}

.animFade-appear-active {
  opacity: 1;
  transition: opacity 1.5s;
}
.animFadeScale-enter {
  opacity: 0;
  transform: scale(0);
}

.animFadeScale-enter-active {
  opacity: 1;
  transform: scale(1);
  transition: all 0.7s ease-out;
  transition-delay: 0.2s;
}

.animFadeScale-exit {
  opacity: 0;
  transform: scale(0);
}

.animFadeScale-exit-active {
  opacity: 1;
  transform: scale(1);
  transition: all 0.7s ease-out;
  transition-delay: 0.2s;
}

.animFadeScale-appear {
  opacity: 0;
  transform: scale(0);
}

.animFadeScale-appear-active {
  opacity: 1;
  transform: scale(1);
  transition: all 0.7s ease-out;
  transition-delay: 0.2s;
}
.animTabs-enter {
  opacity: 0;
}
.animTabs-enter-active {
  opacity: 1;
  transition: opacity 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.animTabs-exit {
  display:none;
  opacity: 0;
}
.animTabs-exit-active {
  display:none;
  opacity: 0;
}
.animTabs-appear {
  opacity: 0;
}
.animTabs-appear-active {
  opacity: 1;
  transition: opacity 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
`;
